/* Predictive search in the search drawer: debounced, keyboard navigable (arrow keys + Enter). */
(function () {
  'use strict';
  class HePredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[name=q]');
      this.results = this.querySelector('[data-results]');
      this.cache = {};
      this.run = window.HE.debounce(this.search.bind(this), 250);
      this.input.addEventListener('input', () => this.run());
      this.input.addEventListener('keydown', this.onKey.bind(this));
    }
    search() {
      const q = this.input.value.trim();
      if (!q) { this.clear(); return; }
      if (this.cache[q]) { this.show(this.cache[q]); return; }
      const p = new URLSearchParams({ q: q, section_id: 'predictive-search', 'resources[limit]': this.dataset.limit || 4, 'resources[options][prefix]': 'last' });
      p.set('resources[type]', this.dataset.types || 'product,article,page');
      const req = (this.req = (this.req || 0) + 1);
      fetch(this.dataset.url + '?' + p.toString())
        .then((r) => r.text())
        .then((html) => {
          if (req !== this.req) return;
          const el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-predictive]');
          const out = el ? el.outerHTML : '';
          this.cache[q] = out; this.show(out);
        }).catch(() => {});
    }
    show(html) {
      this.results.innerHTML = html;
      this.classList.toggle('has-results', !!html);
      this.input.setAttribute('aria-expanded', html ? 'true' : 'false');
      this.input.removeAttribute('aria-activedescendant');
      this.index = -1;
    }
    clear() { this.show(''); }
    /* ARIA combobox pattern: the input (role=combobox) keeps focus and carries aria-activedescendant;
       the role=option items carry their id and aria-selected. */
    options() { return Array.from(this.results.querySelectorAll('[role="option"]')); }
    onKey(e) {
      const options = this.options();
      if (!options.length || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Enter')) return;
      if (e.key === 'Enter') {
        const link = this.index >= 0 && options[this.index] ? options[this.index].querySelector('a') : null;
        if (link) { e.preventDefault(); link.click(); }
        return;
      }
      e.preventDefault();
      this.index = e.key === 'ArrowDown' ? Math.min(options.length - 1, this.index + 1) : Math.max(-1, this.index - 1);
      options.forEach((o, i) => o.setAttribute('aria-selected', i === this.index ? 'true' : 'false'));
      if (this.index >= 0) { this.input.setAttribute('aria-activedescendant', options[this.index].id); options[this.index].scrollIntoView({ block: 'nearest' }); }
      else this.input.removeAttribute('aria-activedescendant');
    }
  }
  if (!customElements.get('he-predictive-search')) customElements.define('he-predictive-search', HePredictiveSearch);
})();
